

import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
} from "@material-ui/core";

const pointColors: any = {
    "20": "#7BC96F",
    "40": "#F5C242",
    "60": "#3B82F6",
    "80": "#E5E7EB",
};

interface Props {
    selectedModule: any;
}

export const EdgeModulePreview = ({
    selectedModule,
}: Props) => {

    const renderLocation = (
        locationData: any,
        title: string,
        positionStyles: any,
        reverse?: boolean,
        alignRight?: boolean
    ) => {

        if (!locationData) return null;

        let entries: any = Object.entries(
            locationData.thickness || {}
        );

        if (reverse) {
            entries = [...entries].reverse();
        }

        return (
            <Box position="absolute" {...positionStyles}>

                <Typography
                    style={{
                        color: "white",
                        fontWeight: 700,
                        marginBottom: 5,
                        fontSize: 12,
                        textAlign: alignRight ? "right" : "left",
                    }}
                >
                    {title}
                </Typography>

                {entries.map(([key, value]: any) => (

                    <Box
                        key={key}
                        display="flex"
                        alignItems="center"
                        justifyContent={
                            alignRight ? "flex-end" : "flex-start"
                        }
                        mb={1}
                    >

                        {alignRight ? (
                            <>
                                <Box
                                    style={{
                                        background: "white",
                                        borderRadius: 10,
                                        // padding: "4px 8px",
                                        fontSize: 10,
                                        minWidth: 30,
                                        textAlign: "center",
                                        marginRight: 5,

                                    }}
                                >
                                    {value}
                                </Box>

                                <Typography
                                    style={{
                                        width: 40,
                                        color: "black",
                                        fontSize: 10,
                                        fontWeight: 700,
                                    }}
                                >
                                    {locationData?.outside_edge?.[key]} mm
                                </Typography>

                                <Box
                                    ml={1}
                                    width={12}
                                    height={12}
                                    
                                    style={{
                                        background: pointColors[key],
                                        border: "1.5px solid black",
                                        transform: "rotate(45deg)",
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <Box
                                    mr={1}
                                    width={12}
                                    height={12}
                                    
                                    style={{
                                        background: pointColors[key],
                                        border: "1.5px solid black",
                                        transform: "rotate(45deg)",
                                    }}
                                />

                                <Typography
                                    style={{
                                        width: 40,
                                        color: "black",
                                        fontSize: 10,
                                        fontWeight: 700,
                                    }}
                                >
                                    {locationData?.outside_edge?.[key]} mm
                                </Typography>

                                <Box
                                    style={{
                                        background: "white",
                                        borderRadius: 10,
                                        // padding: "4px 8px",
                                        fontSize: 10,
                                        minWidth: 30,
                                        textAlign: "center",
                                        marginRight: 5,
                                    }}
                                >
                                    {value}
                                </Box>
                            </>
                        )}

                    </Box>
                ))}
            </Box>
        );
    };

    return (
        <Card style={{ width: 350 }}>

            <CardContent>

                <Typography
                    variant="h5"
                    gutterBottom
                >
                    Module Preview
                </Typography>

                <Box
                    position="relative"
                    height={580}
                    borderRadius={12}
                    style={{
                        background:
                            "linear-gradient(180deg,#1fa4b5,#178d9d)",
                        border: "6px solid #D94132",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        position="absolute"
                        top={8}
                        left="50%"
                        style={{
                            transform: "translateX(-50%)",
                            color: "#111827",
                            fontWeight: 900,
                            fontSize: 9,
                            letterSpacing: 1,
                        }}
                    >
                        MODULE TOP
                    </Box>

                    {/* CENTER LINES */}
                    <Box
                        position="absolute"
                        top="50%"
                        left={0}
                        right={0}
                        borderTop="2px dashed rgba(255,255,255,0.4)"
                    />

                    <Box
                        position="absolute"
                        left="50%"
                        top={0}
                        bottom={0}
                        borderLeft="2px dashed rgba(255,255,255,0.4)"
                    />


                    {/* J BOXES */}
                    <Box
                        position="absolute"
                        top="50%"
                        left="50%"
                        style={{
                            transform: "translate(-50%, -50%)",
                            display: "flex",
                            alignItems: "center",
                            gap: 50,
                        }}
                    >
                        {[1, 2, 3].map((item) => (
                            <Box
                                key={item}
                                style={{
                                    background: "#0B4EA2",
                                    color: "white",
                                    // padding: "4px 14px",
                                    borderRadius: 4,
                                    fontWeight: 700,
                                    fontSize: 12,
                                    minWidth: 50,
                                    textAlign: "center",
                                }}
                            >
                                J-box
                            </Box>
                        ))}
                    </Box>

                    {renderLocation(
                        selectedModule?.locations?.[0],
                        "Location 1",
                        { top: 10, left: 10 }
                    )}

                    {renderLocation(
                        selectedModule?.locations?.[1],
                        "Location 2",
                        { top: 10, right: 10 },
                        false,
                        true
                    )}

                    {renderLocation(
                        selectedModule?.locations?.[2],
                        "Location 3",
                        { bottom: 10, left: 10 },
                        true
                    )}

                    {renderLocation(
                        selectedModule?.locations?.[3],
                        "Location 4",
                        { bottom: 10, right: 10 },
                        true,
                        true
                    )}

                </Box>
                <Typography
                    style={{
                        marginTop: 12,
                        fontSize: 12,
                        color: "#4B5563",
                        lineHeight: 1.5,
                    }}
                >
                    Figure shows the front view of the module. Jbox is added
                    as a reference to visualize the center line. The
                    measurements are taken while keeping the module facing
                    up on a table.
                </Typography>

            </CardContent>

        </Card>
    );
};